import { makeAutoObservable } from 'mobx';

export default class Staff {
  data = {};

  constructor(personData) {
    this.data = personData;
    makeAutoObservable(this);
  }

  get fullName() {
    return `${this.data.lastname || ''} ${this.data.firstname || ''} ${this.data.middlename || ''}`
      .replace(/\s{2,}/g, ' ').trim();
  }

  get userId() {
    return this.data.staffid;
  }
}
